import ResourceManager from "./ResourceManager";

const RESOURCES = {
  "hero-slides": {
    key: "hero-slides",
    label: "Hero Slide",
    route: "hero-slides",
    entity: "hero_slides",
    titleField: "title",
    fields: [
      { name: "title", label: "Title", type: "text" },
      { name: "tagline", label: "Tagline", type: "text" },
      { name: "description", label: "Description", type: "textarea" },
      { name: "cta_label", label: "CTA Label", type: "text" },
      { name: "cta_link", label: "CTA Link", type: "text" },
      { name: "image_url", label: "Background Image", type: "image" },
      { name: "images", label: "Sub-images (comma-separated URLs)", type: "list" },
      { name: "tags", label: "Hashtags (comma-separated, e.g. AI, Finance)", type: "list" },
      { name: "text_position", label: "Text Card Position (left / center / right)", type: "text" },
      { name: "order", label: "Order", type: "number" },
      { name: "status", label: "Status (Draft / Published)", type: "status" },
      { name: "is_active", label: "Active", type: "boolean" },
    ],
  },
  projects: {
    key: "projects",
    label: "Project",
    route: "projects",
    entity: "projects",
    titleField: "name",
    fields: [
      { name: "name", label: "Project Name", type: "text" },
      { name: "category", label: "Category", type: "text" },
      { name: "client", label: "Client", type: "text" },
      { name: "year", label: "Year", type: "text" },
      { name: "duration", label: "Duration", type: "text" },
      { name: "summary", label: "Summary", type: "textarea" },
      { name: "problem", label: "Problem", type: "textarea" },
      { name: "solution", label: "Solution", type: "textarea" },
      { name: "impact", label: "Impact", type: "textarea" },
      { name: "metrics", label: "Metrics (comma-separated)", type: "list" },
      { name: "tech_stack", label: "Tech Stack (comma-separated)", type: "list" },
      { name: "tags", label: "Tags (comma-separated)", type: "list" },
      { name: "featured", label: "Featured (bubble to top)", type: "boolean" },
      { name: "image_url", label: "Cover Image", type: "image" },
      { name: "gallery", label: "Gallery (comma-separated image URLs)", type: "list" },
      { name: "order", label: "Order", type: "number" },
      { name: "status", label: "Status (Draft / Published)", type: "status" },
      { name: "is_active", label: "Active", type: "boolean" },
    ],
  },
  leaders: {
    key: "leaders",
    label: "Leader",
    route: "leaders",
    entity: "leaders",
    titleField: "name",
    fields: [
      { name: "name", label: "Full Name", type: "text" },
      { name: "designation", label: "Designation", type: "text" },
      { name: "bio", label: "Biography", type: "textarea" },
      { name: "photo_url", label: "Photo", type: "image" },
      { name: "linkedin", label: "LinkedIn URL", type: "text" },
      { name: "twitter", label: "Twitter URL", type: "text" },
      { name: "category", label: "Category (board / advisory)", type: "text" },
      { name: "order", label: "Order", type: "number" },
      { name: "status", label: "Status (Draft / Published)", type: "status" },
      { name: "is_active", label: "Active", type: "boolean" },
    ],
  },
  blogs: {
    key: "blogs",
    label: "Blog",
    route: "blogs",
    entity: "blogs",
    titleField: "title",
    fields: [
      { name: "title", label: "Title", type: "text" },
      { name: "excerpt", label: "Excerpt", type: "textarea" },
      { name: "body", label: "Body", type: "textarea" },
      { name: "category", label: "Category", type: "text" },
      { name: "cover_image", label: "Cover Image", type: "image" },
      { name: "author", label: "Author", type: "text" },
      { name: "published_at", label: "Published Date (YYYY-MM-DD)", type: "text" },
      { name: "status", label: "Status (Draft / Published)", type: "status" },
      { name: "is_active", label: "Active", type: "boolean" },
    ],
  },
  careers: {
    key: "careers",
    label: "Career",
    route: "careers",
    entity: "careers",
    titleField: "title",
    fields: [
      { name: "title", label: "Job Title", type: "text" },
      { name: "department", label: "Department", type: "text" },
      { name: "location", label: "Location", type: "text" },
      { name: "employment_type", label: "Employment Type", type: "text" },
      { name: "description", label: "Description", type: "textarea" },
      { name: "requirements", label: "Requirements (comma-separated)", type: "list" },
      { name: "status", label: "Status (Draft / Published)", type: "status" },
      { name: "is_active", label: "Active", type: "boolean" },
    ],
  },
};

export const HeroSlidesAdmin = () => <ResourceManager resource={RESOURCES["hero-slides"]} />;
export const ProjectsAdmin = () => <ResourceManager resource={RESOURCES.projects} />;
export const LeadersAdmin = () => <ResourceManager resource={RESOURCES.leaders} />;
export const BlogsAdmin = () => <ResourceManager resource={RESOURCES.blogs} />;
export const CareersAdmin = () => <ResourceManager resource={RESOURCES.careers} />;
